import { error } from "toastr";
import {
    POST_DYNATRACE_ENABLE_DISABLE_ALERTS,
    POST_DYNATRACE_ENABLE_DISABLE_ALERTS_FAIL,
    POST_DYNATRACE_ENABLE_DISABLE_ALERTS_SUCCESS,
    POST_DYNATRACE_CREATE_RESOURCE_ALERTS,
    POST_DYNATRACE_CREATE_RESOURCE_ALERTS_FAIL,
    POST_DYNATRACE_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_DYNATRACE_CREATE_DYNAMIC_ALERT,
    POST_DYNATRACE_CREATE_DYNAMIC_ALERT_FAIL,
    POST_DYNATRACE_CREATE_DYNAMIC_ALERT_SUCCESS,
    GET_DYNATRACE_ALERTS,
    GET_DYNATRACE_ALERTS_FAIL,
    GET_DYNATRACE_ALERTS_SUCCESS,
    GET_DYNATRACE_DYNAMIC_ALERTS,
    GET_DYNATRACE_DYNAMIC_ALERTS_FAIL,
    GET_DYNATRACE_DYNAMIC_ALERTS_SUCCESS,
    GET_DYNATRACE_MISSING_DYNAMIC_ALERTS,
    GET_DYNATRACE_MISSING_DYNAMIC_ALERTS_FAIL,
    GET_DYNATRACE_MISSING_DYNAMIC_ALERTS_SUCCESS,
    GET_DYNATRACE_DEFAULT_THRESHOLD,
    GET_DYNATRACE_DEFAULT_THRESHOLD_FAIL,
    GET_DYNATRACE_DEFAULT_THRESHOLD_SUCCESS,
    GET_DYNATRACE_RESOURCE_BY_ID,
    GET_DYNATRACE_RESOURCE_BY_ID_FAIL,
    GET_DYNATRACE_RESOURCE_BY_ID_SUCCESS,
    GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
    GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
    POST_DYNATRACE_ALERT,
    POST_DYNATRACE_ALERT_FAIL,
    POST_DYNATRACE_ALERT_SUCCESS,
    GET_DYNATRACE_RESCAN,
    GET_DYNATRACE_RESCAN_FAIL,
    GET_DYNATRACE_RESCAN_SUCCESS,
    GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID,
    GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
    GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
    POST_DYNATRACE_SERVICE_MAPPING,
    POST_DYNATRACE_SERVICE_MAPPING_FAIL,
    POST_DYNATRACE_SERVICE_MAPPING_SUCCESS,
    POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    GET_DYNATRACE_RESOURCES,
    GET_DYNATRACE_RESOURCES_FAIL,
    GET_DYNATRACE_RESOURCES_SUCCESS,
    GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES,
    GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES_FAIL,
    GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES_SUCCESS,
    GET_RESCAN_STATUS_DYNATRACE,
    GET_RESCAN_STATUS_DYNATRACE_FAIL,
    GET_RESCAN_STATUS_DYNATRACE_SUCCESS,
    POST_UPDATE_DYNATRACE_THRESHOLD,
    POST_UPDATE_DYNATRACE_THRESHOLD_FAIL,
    POST_UPDATE_DYNATRACE_THRESHOLD_SUCCESS,
    POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD,
    POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD_FAIL,
    POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD_SUCCESS,
    GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_DYNATRACE_THRESHOLD,
    GET_DYNATRACE_THRESHOLD_FAIL,
    GET_DYNATRACE_THRESHOLD_SUCCESS,
    GET_DYNATRACE_ALL_KEY_USER_ACTIONS,
    GET_DYNATRACE_ALL_KEY_USER_ACTIONS_FAIL,
    GET_DYNATRACE_ALL_KEY_USER_ACTIONS_SUCCESS,
    GET_DYNATRACE_ALL_USER_ACTIONS,
    GET_DYNATRACE_ALL_USER_ACTIONS_FAIL,
    GET_DYNATRACE_ALL_USER_ACTIONS_SUCCESS,
    POST_CREATE_KEY_USER_ACTION,
    POST_CREATE_KEY_USER_ACTION_FAIL,
    POST_CREATE_KEY_USER_ACTION_SUCCESS,

} from "./actionTypes";
import { data } from "autoprefixer";

export const postEnableDisableDynatraceThreshold = (data) => ({
    type: POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD,
    payload: data,
})

export const postEnableDisableDynatraceThresholdFail = error => ({
    type: POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD_FAIL,
    payload: error,
})

export const postEnableDisableDynatraceThresholdSuccess = (response) => ({
    type: POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD_SUCCESS,
    payload: response,
})

export const postUpdateDynatraceThreshold = (data) => ({
    type: POST_UPDATE_DYNATRACE_THRESHOLD,
    payload: data
})

export const postUpdateDynatraceThresholdFail = error => ({
    type: POST_UPDATE_DYNATRACE_THRESHOLD_FAIL,
    payload: error
})

export const postUpdateDynatraceThresholdSuccess = (response) => ({
    type: POST_UPDATE_DYNATRACE_THRESHOLD_SUCCESS,
    payload: response
})

export const getRescanStatusDynatrace = (data) => ({
    type: GET_RESCAN_STATUS_DYNATRACE,
    payload: data
})

export const getRescanStatusDynatraceFail = error => ({
    type: GET_RESCAN_STATUS_DYNATRACE_FAIL,
    payload: error
})

export const getRescanStatusDynatraceSuccess = (dynatrace_rescan_status) => ({
    type: GET_RESCAN_STATUS_DYNATRACE_SUCCESS,
    payload: dynatrace_rescan_status
})

export const getDynatraceRefresh = () => ({
    type: GET_DYNATRACE_RESCAN,
    payload: []
})

export const getDynatraceRefreshFail = error => ({
    type: GET_DYNATRACE_RESCAN_FAIL,
    payload: error
})

export const getDynatraceRefreshSuccess = (data) => ({
    type: GET_DYNATRACE_RESCAN_SUCCESS,
    payload: data
})

export const getDynatraceResources = () => ({
    type: GET_DYNATRACE_RESOURCES,
})

export const getDynatraceResourcesFail = error => ({
    type: GET_DYNATRACE_RESOURCES_FAIL,
    payload: error
})

export const getDynatraceResourcesSuccess = dynatrace_resources => ({
    type: GET_DYNATRACE_RESOURCES_SUCCESS,
    payload: dynatrace_resources
})

export const getDynatraceMissingAlertByResourceId = (monitored_resource_id) => ({
    type: GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID,
    payload: monitored_resource_id
})

export const getDynatraceMissingAlertByResourceIdFail = error => ({
    type: GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getDynatraceMissingAlertsByResourceIdSuccess = (response) => ({
    type: GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
    payload: response
})

export const getDynatraceAllResourceAlertsPage = (data) => ({
    type: GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE,
    payload: data
})

export const getDynatraceAllResourceAlertsPageFail = error => ({
    type: GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error
})

export const getDynatraceAllResourceAlertsPageSuccess = (dynatrace_all_resource_alerts) => ({
    type: GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: dynatrace_all_resource_alerts
})

export const getDynatraceAllResourceAlertsCountPage = (data) => ({
    type: GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE,
    payload: data
})

export const getDynatraceAllResourceAlertsCountPageFail = error => ({
    type: GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
    payload: error
})

export const getDynatraceAllResourceAlertsCountPageSuccess = (dynatrace_all_resource_alerts_count) => ({
    type: GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
    payload: dynatrace_all_resource_alerts_count
})

export const postDynatraceAlert = (data) => ({
    type: POST_DYNATRACE_ALERT,
    payload: data
})

export const postDynatraceAlertFail = error => ({
    type: POST_DYNATRACE_ALERT_FAIL,
    payload: error
})

export const postDynatraceAlertSuccess = (response) => ({
    type: POST_DYNATRACE_ALERT_SUCCESS,
    payload: response
})

export const postDynatraceServiceMapping = (data) => ({
    type: POST_DYNATRACE_SERVICE_MAPPING,
    payload: data
})

export const postDynatraceServiceMappingFail = error => ({
    type: POST_DYNATRACE_SERVICE_MAPPING_FAIL,
    payload: error
})

export const postDynatraceServiceMappingSuccess = (response) => ({
    type: POST_DYNATRACE_SERVICE_MAPPING_SUCCESS,
    payload: response
})

export const postDynatraceResourceOpsGenieTeamMapping = (data) => ({
    type: POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: data
})

export const postDynatraceResourceOpsGenieTeamMappingFail = error => ({
    type: POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    payload: error
})

export const postDynatraceResourceOpsGenieTeamMappingSuccess = (response) => ({
    type: POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    payload: response
})

export const postDynatraceResourcePagerdutyMapping = (data) => ({
    type: POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    payload: data
})

export const postDynatraceResourcePagerdutyMappingFail = error => ({
    type: POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    payload: error
})

export const postDynatraceResourcePagerdutyMappingSuccess = (response) => ({
    type: POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    payload: response
})

export const getAllOrgDynatraceResourceTypes = () => ({
    type: GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES
})

export const getAllOrgDynatraceResourceTypesFail = error => ({
    type: GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES_FAIL,
    payload: error
})

export const getAllOrgDynatraceResourceTypesSuccess = orgDynatraceResourceTypes => ({
    type: GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES_SUCCESS,
    payload: orgDynatraceResourceTypes
})


export const postDynatraceEnableDisableAlerts = (data) => ({
    type: POST_DYNATRACE_ENABLE_DISABLE_ALERTS,
    payload: data
})

export const postDynatraceEnableDisableAlertsFail = error =>({
    type: POST_DYNATRACE_ENABLE_DISABLE_ALERTS_FAIL,
    payload: error
})

export const postDynatraceEnableDisableAlertsSuccess = (response) => ({
    type: POST_DYNATRACE_ENABLE_DISABLE_ALERTS_SUCCESS,
    payload: response
})

export const postDynatraceCreateResourceAlerts = data => ({
    type: POST_DYNATRACE_CREATE_RESOURCE_ALERTS,
    payload: data
})

export const postDynatraceCreateResourceAlertsFail = error => ({
    type: POST_DYNATRACE_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error
})

export const postDynatraceCreateResourceAlertsSuccess = (response) => ({
    type: POST_DYNATRACE_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: response
})

export const postDynatraceCreateDynamicAlert = data =>({
    type: POST_DYNATRACE_CREATE_DYNAMIC_ALERT,
    payload: data
})

export const postDynatraceCreateDynamicAlertSuccess = (response) => ({
    type: POST_DYNATRACE_CREATE_DYNAMIC_ALERT_SUCCESS,
    payload: response
})

export const postDynatraceCreateDynamicAlertFail = error => ({
    type: POST_DYNATRACE_CREATE_DYNAMIC_ALERT_FAIL,
    payload: error
})

export const getDynatraceAlerts = (monitored_resource_id) => (
    {
        type: GET_DYNATRACE_ALERTS,
        payload: monitored_resource_id
    }
)

export const getDynatraceAlertsSuccess = dynatrace_alerts => ({
    type: GET_DYNATRACE_ALERTS_SUCCESS,
    payload: dynatrace_alerts
})

export const getDynatraceAlertsFail = error => ({
    type: GET_DYNATRACE_ALERTS_FAIL,
    payload: error
})

export const getDynatraceDynamicAlerts = (monitored_resource_id) => ({
    type: GET_DYNATRACE_DYNAMIC_ALERTS,
    payload: monitored_resource_id
})

export const getDynatraceDynamicAlertsSuccess = dynatrace_dynamic_alerts => ({
    type: GET_DYNATRACE_DYNAMIC_ALERTS_SUCCESS,
    payload: dynatrace_dynamic_alerts
})

export const getDynatraceDynamicAlertsFail = error => ({
    type: GET_DYNATRACE_DYNAMIC_ALERTS_FAIL,
    payload: error
})

export const getDynatraceMissingDynamicAlerts = (monitored_resource_id) => ({
    type: GET_DYNATRACE_MISSING_DYNAMIC_ALERTS,
    payload: monitored_resource_id
})

export const getDynatraceMissingDynamicAlertsFail = error => ({
    type: GET_DYNATRACE_MISSING_DYNAMIC_ALERTS_FAIL,
    payload: error
})

export const getDynatraceMissingDynamicAlertsSuccess = dynatrace_missing_dynamic_alerts => ({
    type: GET_DYNATRACE_MISSING_DYNAMIC_ALERTS_SUCCESS,
    payload: dynatrace_missing_dynamic_alerts
})

export const getDynatraceDefaultThreshold = threshold_type => ({
    type: GET_DYNATRACE_DEFAULT_THRESHOLD,
    payload: threshold_type
})

export const getDynatraceDefaultThresholdFail = error => ({
    type: GET_DYNATRACE_DEFAULT_THRESHOLD_FAIL,
    payload: error
})

export const getDynatraceDefaultThresholdSuccess = defaultThreshold => ({
    type: GET_DYNATRACE_DEFAULT_THRESHOLD_SUCCESS,
    payload: defaultThreshold
})

export const getDynatraceThreshold = metric_id => ({
    type: GET_DYNATRACE_THRESHOLD,
    payload: metric_id
})

export const getDynatraceThresholdFail = error => ({
    type: GET_DYNATRACE_THRESHOLD_FAIL,
    payload: error
})

export const getDynatraceThresholdSuccess = appDynamicsThreshold => ({
    type: GET_DYNATRACE_THRESHOLD_SUCCESS,
    payload: appDynamicsThreshold
})

export const getDynatraceResourceById = monitored_resource_id => ({
    type: GET_DYNATRACE_RESOURCE_BY_ID,
    payload: monitored_resource_id
})

export const getDynatraceResourceByIdSuccess = dynatrace_resource => ({
    type: GET_DYNATRACE_RESOURCE_BY_ID_SUCCESS,
    payload: dynatrace_resource
})

export const getDynatraceResourceByIdFail = error => ({
    type: GET_DYNATRACE_RESOURCE_BY_ID_FAIL,
    payload: error
})

export const getDynatraceResourcesDefaultThresholdById = monitored_resource_id => (
    {
        type: GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
        payload: monitored_resource_id
    }
)

export const getDynatraceResourcesDefaultThresholdByIdSuccess = dynatrace_resource_default_threshold => ({
    type: GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
    payload: dynatrace_resource_default_threshold
})

export const getDynatraceResourcesDefaultThresholdByIdFail = error => ({
    type: GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
    payload: error
})

export const getMissingDynatraceAlertsByResourceID = data => ({
    type: GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getMissingDynatraceAlertsByResourceIDSuccess = dynatrace_resource_missing_alerts => ({
    type: GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: dynatrace_resource_missing_alerts,
})

export const getMissingDynatraceAlertsByResourceIDFail = error => ({
    type: GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error,
})



export const getDynatraceAllKeyUserActions = (data) => ({
    type: GET_DYNATRACE_ALL_KEY_USER_ACTIONS,
    payload: data
})

export const getDynatraceAllKeyUserActionsFail = error => ({
    type: GET_DYNATRACE_ALL_KEY_USER_ACTIONS_FAIL,
    payload: error
})

export const getDynatraceAllKeyUserActionsSuccess = (dynatrace_all_resource_alerts) => ({
    type: GET_DYNATRACE_ALL_KEY_USER_ACTIONS_SUCCESS,
    payload: dynatrace_all_resource_alerts
})


export const getDynatraceAllUserActions = (data) => ({
    type: GET_DYNATRACE_ALL_USER_ACTIONS,
    payload: data
})

export const getDynatraceAllUserActionsFail = error => ({
    type: GET_DYNATRACE_ALL_USER_ACTIONS_FAIL,
    payload: error
})

export const getDynatraceAllUserActionsSuccess = (dynatrace_all_resource_alerts) => ({
    type: GET_DYNATRACE_ALL_USER_ACTIONS_SUCCESS,
    payload: dynatrace_all_resource_alerts
})

export const postCreateKeyUserAction = (data) => ({
    type: POST_CREATE_KEY_USER_ACTION,
    payload: data
})

export const postCreateKeyUserActionFail = error => ({
    type: POST_CREATE_KEY_USER_ACTION_FAIL,
    payload: error
})

export const postCreateKeyUserActionSuccess = (response) => ({
    type: POST_CREATE_KEY_USER_ACTION_SUCCESS,
    payload: response
})